export default {
  'sendticket.sendticket': 'ارسال درخواست',
  'sendticket.sentsuccessfully': 'با موفقیت ارسال شد',
  'sendticket.replytickets': 'پاسخ به درخواست ها',
  'sendticket.you': 'شما',
  'sendticket.operator': 'اپراتور',
  'sendticket.reply': 'پاسخ',
  'sendticket.createdat': 'ایجاد شده در',
  'sendticket.laststatus': 'آخرین وضعیت',
  'sendticket.ticketid': 'شماره درخواست',
  'sendticket.closeticketquestion': 'آیا درخواست شما با موفقیت پاسخ گویی شد ؟',
  'sendticket.closeticket': 'بله ، این درخواست را ببند',
  'sendticket.notcloseticket': 'خیر',
  'sendticket.closedsuccessfully': 'درخواست با موفقیت بسته شد',
  'sendticket.downloadfile': 'دریافت فایل',
  'sendticket.subject': 'موضوع',
  'sendticket.ticketId': 'شناسه درخواست',
  'sendticket.sender': 'فرستنده',
  'sendticket.reply': 'پاسخ',
  'sendticket.yes': 'بله ، پاسخ داده شد ',
  'sendticket.no': 'خیر ',
  'sendticket.pleaseTryAgain': 'لطفا مجددا تلاش کنید ',
  'sendticket.today': '( امروز) ',
  'sendticket.yesterday': '( دیروز ) ',
  'sendticket.daysago': 'روز قبل',
  'sendticket.hoursago': 'ساعت قبل',
  'sendticket.minutesago': 'دقیقه قبل',
  'sendticket.send': 'ارسال',
  'sendticket.description': 'توضیحات',
  'sendticket.justnow': 'همین الان',
};
